import { useState, useCallback } from 'react'

const useForceUpdate = () => {
	const [forceUpdate, setForceUpdate] = useState()

	const update = useCallback(() => setForceUpdate(Math.random()), [])

	return [forceUpdate, update]
}

export default useForceUpdate
